//@flow
import {makeStyles} from '@material-ui/core';
import {Publish} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {colors} from '../../../../../../../assets/styles/colors';
import CropModal from '../../../../../../../elements/CropModal';
import type {DynamicAspectRatio} from '../../../../../../../elements/CropModal';

type Props = {
  aspectRatio: number,
  label: string,
  onChange: (file: File) => void,
  resetTrigger?: boolean,
  dynamicAspectRatio?: DynamicAspectRatio,
  error?: boolean,
  helperText?: string,
  value?: File,
};

type StyleProps = {
  aspect: number,
  error?: boolean,
};

const useStyles = ({aspect, error}: StyleProps) =>
  makeStyles(theme => ({
    uploadButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '0.5rem',
      borderRadius: '0.75rem',
      padding: '1rem',
      color: error ? colors.error : colors.primary,
      border: `2px dashed ${error ? colors.error : colors.grey500}`,
      cursor: 'pointer',
      position: 'relative',
      height: '150px',
      width: '100%',
    },
    labelContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.25rem',
    },
    imagePreview: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: '0.75rem',
    },
  }));

export default function ImageInput(props: Props) {
  const {
    aspectRatio,
    label,
    onChange,
    resetTrigger,
    dynamicAspectRatio,
    error,
    value,
  } = props;

  const classes = useStyles({
    aspect: aspectRatio,
    error,
  })();

  const [file, setFile] = useState<File | null>(null);
  const [fileCropped, setFileCropped] = useState<File | null>(
    value ? value : null
  );
  /*   const [fileCroppedPreview, setFileCroppedPreview] = useState<string | null>(
    null
  ); */

  useEffect(() => {
    setFileCropped(value ? value : null);
  }, [value]);

  const fileCroppedPreview = fileCropped
    ? URL.createObjectURL(fileCropped)
    : null;

  useEffect(() => {
    if (!fileCroppedPreview) return;

    return () => {
      URL.revokeObjectURL(fileCroppedPreview);
    };
  }, [fileCroppedPreview]);

  useEffect(() => {
    setFile(null);
  }, [resetTrigger]);

  const handleUpload = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const file = event.target.files[0];

    if (!file) return;
    event.target.value = '';
    setFile(file);
  };

  return (
    <>
      <label className={classes.uploadButton}>
        {fileCroppedPreview ? (
          <img
            src={fileCroppedPreview}
            alt="mobile"
            className={classes.imagePreview}
          />
        ) : (
          <>
            <Publish />
            <div className={classes.labelContainer}>
              <span className={classes.uploadLabel}>{label}</span>
            </div>
          </>
        )}
        <input type="file" hidden onChange={handleUpload} accept="image/*" />
      </label>

      {file && (
        <CropModal
          open
          keepFormat
          onClose={() => {
            setFile(null);
          }}
          onSubmit={results => {
            const [result] = results;

            onChange(result.file);
            setFile(null);
          }}
          aspect={aspectRatio}
          images={[{preview: URL.createObjectURL(file), file}]}
          dynamicAspectRatio={dynamicAspectRatio}
        />
      )}
    </>
  );
}
